import { defineComponent as _defineComponent } from 'vue'
import NavBarBreadcrumb from './components/NavBarBreadcrumb.vue'
import NavBarHelp from './components/NavBarHelp.vue'
import NavBarLogo from './components/NavBarLogo.vue'
import NavBarMenu from './components/NavBarMenu.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {


return { __sfc: true,NavBarBreadcrumb, NavBarHelp, NavBarLogo, NavBarMenu }
}

})